/**
 * Code symbols (programming & technical symbols)
 */
export const SYMBOL_ICONS = [
  // Brackets & Delimiters
  { value: '{ }', label: 'braces' },
  { value: '[ ]', label: 'brackets' },
  { value: '( )', label: 'parens' },
  { value: '< >', label: 'angle-brackets' },
  { value: '</', label: 'close-tag' },
  { value: '/>', label: 'self-close' },
  // Operators
  { value: '=>', label: 'arrow' },
  { value: '->', label: 'thin-arrow' },
  { value: '::', label: 'scope' },
  { value: '...', label: 'spread' },
  { value: '??', label: 'nullish' },
  { value: '?:', label: 'ternary' },
  { value: '&&', label: 'and' },
  { value: '||', label: 'or' },
  { value: '===', label: 'strict-equal' },
  { value: '!==', label: 'strict-not-equal' },
  // Common Symbols
  { value: '#', label: 'hash' },
  { value: '@', label: 'at' },
  { value: '$', label: 'dollar' },
  { value: '%', label: 'percent' },
  { value: '&', label: 'ampersand' },
  { value: '*', label: 'asterisk' },
  { value: '~', label: 'tilde' },
  { value: '^', label: 'caret' },
  { value: '|', label: 'pipe' },
  { value: '\\', label: 'backslash' },
  // Technical
  { value: '/**/', label: 'comment' },
  { value: '//', label: 'line-comment' },
  { value: '/*', label: 'block-start' },
  { value: '*/', label: 'block-end' },
  { value: '<?>', label: 'generic' },
  { value: '0x', label: 'hex' },
  { value: '0b', label: 'binary' },
  { value: 'fn', label: 'function' },
  { value: 'λ', label: 'lambda' },
  { value: '∑', label: 'sum' },
  { value: '∏', label: 'product' },
  { value: '∞', label: 'infinity' },
  { value: '≈', label: 'approx' },
  { value: '≠', label: 'not-equal' },
  { value: '≤', label: 'lte' },
  { value: '≥', label: 'gte' },
  // Misc
  { value: '▶', label: 'play' },
  { value: '■', label: 'stop' },
  { value: '●', label: 'circle' },
  { value: '◆', label: 'diamond' },
  { value: '★', label: 'star' },
  { value: '☆', label: 'star-outline' },
  { value: '✓', label: 'checkmark' },
  { value: '✗', label: 'x-mark' },
  { value: '→', label: 'right-arrow' },
  { value: '←', label: 'left-arrow' },
  { value: '↑', label: 'up-arrow' },
  { value: '↓', label: 'down-arrow' },
  { value: '↔', label: 'horizontal-arrow' },
  { value: '↕', label: 'vertical-arrow' },
  { value: '⟳', label: 'reload' },
  { value: '⌘', label: 'command' },
  { value: '⌥', label: 'option' },
  { value: '⇧', label: 'shift' },
  { value: '⌫', label: 'delete' }
]

export default SYMBOL_ICONS
